import Ux from '@advisor/models/store/ux';

export const stateObj = function () {
  return new Ux();
};

export const getters = {};

export const actions = {
  searchByClient({commit}, payload) {
    commit('SEARCH_BY_CLIENT', payload);
  },
  searchByAccount({commit}, payload) {
    commit('SEARCH_BY_ACCOUNT', payload);
  },

  changedClient({commit}, payload) {
    commit('CHANGED_CLIENT', payload);
  },

  setGlobalAdvLoader({commit}, payload) {
    commit('SET_GLOBAL_ADV_LOADER', payload);
  },
};

export const mutations = {
  SEARCH_BY_CLIENT(state, payload) {
    state.searchBy.client = payload;
  },
  SEARCH_BY_ACCOUNT(state, payload) {
    state.searchBy.account = payload;
  },
  CHANGED_CLIENT(state, payload) {
    state.changed.client = payload;
  },
  SET_GLOBAL_ADV_LOADER(state, payload) {
    if (payload) {
      state.globalAdvLoader = {...state.globalAdvLoader, ...payload};

      return;
    }

    state.globalAdvLoader = new Ux().globalAdvLoader;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
